const PolygonIcon = (props) => {
  return (
    <svg
      width="60"
      height="40"
      viewBox="0 0 60 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="60" height="40" rx="8" fill="white" />
      <path
        d="M24.18 24.342L18.488 21.055C18.3399 20.969 18.217 20.8458 18.1314 20.6975C18.0457 20.5493 18.0004 20.3812 18 20.21V13.635C18.0003 13.4636 18.0455 13.2953 18.1311 13.1469C18.2167 12.9984 18.3398 12.875 18.488 12.789L24.181 9.50299C24.3296 9.41753 24.4981 9.37256 24.6695 9.37256C24.8409 9.37256 25.0094 9.41753 25.158 9.50299L30.85 12.789C30.9984 12.8749 31.1217 12.9982 31.2075 13.1467C31.2933 13.2951 31.3386 13.4635 31.339 13.635V25.382L35.33 27.686L39.322 25.382V20.772L35.33 18.468L32.697 19.988V16.896L34.842 15.658C34.9906 15.5725 35.1591 15.5276 35.3305 15.5276C35.5019 15.5276 35.6704 15.5725 35.819 15.658L41.512 18.945C41.6602 19.031 41.7833 19.1544 41.8689 19.3029C41.9545 19.4513 41.9997 19.6196 42 19.791V26.364C41.9999 26.5355 41.9548 26.704 41.8691 26.8527C41.7835 27.0013 41.6604 27.1249 41.512 27.211L35.819 30.497C35.6703 30.5823 35.5019 30.6273 35.3305 30.6273C35.1591 30.6273 34.9907 30.5823 34.842 30.497L29.15 27.211C29.0016 27.1251 28.8783 27.0017 28.7925 26.8533C28.7067 26.7048 28.6614 26.5365 28.661 26.365V14.618L28.589 14.577L24.669 12.314L20.679 14.619V19.228L24.669 21.532L27.299 20.015V23.107L25.159 24.343C25.0102 24.4285 24.8416 24.4736 24.67 24.4736C24.4984 24.4736 24.3298 24.4285 24.181 24.343L24.18 24.342Z"
        fill="#7F45DF"
      />
    </svg>
  );
};

export default PolygonIcon;
